import Landing from './Landing';

function scrollToContact() {
  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
}

export default function App() {
  return <Landing onSignIn={scrollToContact} onGetStarted={scrollToContact} />;
}
